export interface RevenuePoint {
  y: number;
  total: number;
  infra: number;
  mecha: number;
  other: number;
  note?: string;
}

// Stacked: infra (critical infrastructure) / mecha / other.  Unit: ¥100M.
export const REVENUE: RevenuePoint[] = [
  { y: 18, total: 195, infra: 78,  mecha: 70,  other: 47 },
  { y: 19, total: 204, infra: 78,  mecha: 80,  other: 46 },
  { y: 20, total: 183, infra: 75,  mecha: 73,  other: 35 },
  { y: 21, total: 210, infra: 84,  mecha: 87,  other: 39 },
  { y: 22, total: 289, infra: 147, mecha: 95,  other: 47 },
  { y: 23, total: 312, infra: 152, mecha: 108, other: 52 },
  { y: 24, total: 382, infra: 213, mecha: 115, other: 54 },
  { y: 25, total: 415, infra: 235, mecha: 132, other: 48 },
];
